import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';


import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { frFR } from '@mui/x-date-pickers/locales';
import frLocale from 'date-fns/locale/fr';



import configureStore from './store/configureStore';

import theme from "./theme";
import App from './components/App';
import axiosHelper from './utils/axiosHelper';

import {
    QueryClient,
    QueryClientProvider,
} from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

// UNLEASH - 
import { FlagProvider } from '@unleash/proxy-client-react';
//const unleashConfigLocalDocker = {
//    url: 'http://localhost:4242/api/frontend', // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
//    clientKey: 'default:development.unleash-insecure-frontend-api-token', // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
//    refreshInterval: 15, // How often (in seconds) the client should poll the proxy for updates
//    appName: 'reclamations', // The name of your application. It's only used for identifying your application
//};
const unleashConfigDEV = {
    url: 'http://unleash.dev.foussier.local/api/frontend', // Your front-end API URL or the Unleash proxy's URL (https://<proxy-url>/proxy)
    clientKey: 'portail-apres-vente:development.357423d77b9d349f074867dd4ed529a67e1ffb6325731c3f73d649d7', // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
    refreshInterval: 15, // How often (in seconds) the client should poll the proxy for updates
    appName: 'portail-apres-vente', // The name of your application. It's only used for identifying your application
    synchronousInitialization: true,
    environment: 'development',
    disableMetrics: true,
    //usePOSTrequests: false
};
const unleashConfigPROD = {
    url: 'https://unleash.foussier.fr/api/frontend', // Endpoint public Unleash (le DNS interne .foussier.local n'est pas résolvable depuis le navigateur des utilisateurs et le HTTPS interne provoquerait du mixed content)
    clientKey: 'portail-apres-vente:production.6a6bebbb0a4922735919b23e615695030869eac84aaebfb1947fe033', // A client-side API token OR one of your proxy's designated client keys (previously known as proxy secrets)
    refreshInterval: 15, // How often (in seconds) the client should poll the proxy for updates
    appName: 'portail-apres-vente', // The name of your application. It's only used for identifying your application
    synchronousInitialization: true,
    environment: 'production',
    disableMetrics: false
};



// Choix de l'environement unleash
let unleash_ENV = 'development';
const hostname = window.location.hostname;
if (!hostname.includes("localhost") && !hostname.includes("dev") && !hostname.includes("recette"))
{
    unleash_ENV = 'production';
}
//console.log("unleash_ENV = ", unleash_ENV);
const unleashConfig = unleash_ENV === 'development' ? unleashConfigDEV : unleashConfigPROD;

if (unleash_ENV === 'development' && hostname.includes("recette")) {
    unleashConfig.disableMetrics = false; // Activation des métriques en recette
}

//console.log("unleashConfig = ", unleashConfig);

// console.log("theme = ", theme);

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

// Config de l'url axios si définie
if (hostname.includes("localhost"))
{
    axiosHelper.setupURL('http://localhost:29998/');
}

// Ajout des intercepteurs axios
axiosHelper.setupInterceptors();


// Initialisation de query client
const queryClient = new QueryClient();


const rootElement = document.getElementById('root');
ReactDOM.render(
    <FlagProvider config={unleashConfig}>
        <QueryClientProvider client={queryClient}>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        adapterLocale={frLocale}
                        localeText={frFR.components.MuiLocalizationProvider.defaultProps.localeText}
                    >
                        <Provider store={store}>
                            <App />
                        </Provider>
                    </LocalizationProvider>
                </ThemeProvider>
            </StyledEngineProvider>
            <ReactQueryDevtools initialIsOpen={false} panelProps={{ style: { width: '80%', left: '0px', right: undefined } }} />
        </QueryClientProvider>
    </FlagProvider>
    ,
    rootElement
);

// Aide pour le ReactQueryDevTools : https://www.npmjs.com/package/react-query-devtools
// position="top-left"
// panelProps > pas jusqu'� la droite pour ne pas cacher le bouton de cr�ation


